module.exports = __webpack_public_path__ + "static/media/starProduct3.c47dc0ba.png";